import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import queryString from 'query-string';
import { lifecycle, compose } from 'recompose';
import { connect } from 'react-redux';
import { storeQueryParams } from '../../actions';
import { hasEphemeralCredentials } from '../../selectors';
import { routerProps } from '../../../../propTypes';

import LayoutWithEmbeddedPasswordForm from './LayoutWithEmbeddedPasswordForm';
import CenterLayout from '../../../../layouts/CenterLayout';
import PasswordResetError from './PasswordResetError';

const SUCCESS = 'success';
const PasswordRequest = (props) => {
  const renderComponent = () => {
    const { location: { search } } = props;
    const querySringObject = queryString.parse(search);
    const isSuccess = querySringObject.state;
    const { ephemeralCredentialsStatus } = props;

    if (!ephemeralCredentialsStatus) {
      /* return <Error> */
      return (<CenterLayout render={() => { return <PasswordResetError />; }} />);
    }

    if (isSuccess === SUCCESS) {
      return (<div>Success</div>);
    }

    return (<CenterLayout render={() => { return <LayoutWithEmbeddedPasswordForm />; }} />);
  };

  return (
    <div>
      {renderComponent()}
    </div>
  );
};


PasswordRequest.propTypes = exact({
  ...routerProps,
  storeQueryParamsAction: PropTypes.func.isRequired,
  ephemeralCredentialsStatus: PropTypes.bool.isRequired,
});

const mapStateToProps = (state) => {
  return {
    ephemeralCredentialsStatus: hasEphemeralCredentials(state),
  };
};

const mapDispatchToProps = {
  storeQueryParamsAction: storeQueryParams,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const withEphemeralCredentials = lifecycle({
  componentDidMount() {
    const { location, storeQueryParamsAction } = this.props;
    storeQueryParamsAction(location.search);
  },
});


const enhance = compose(
  withRedux,
  withEphemeralCredentials,
);


export default enhance(PasswordRequest);
